module.exports = __webpack_public_path__ + "img/separator14.477cfab2.svg";